import clsx from 'clsx';
import styles from '../style.module.scss';
import { useContextSystem } from '../../context';
export function useBorderBoxControlSplitControls(props) {
  const {
    className,
    colors = [],
    enableAlpha = false,
    enableStyle = true,
    __experimentalIsRenderedInSidebar = false,
    ...otherProps
  } = useContextSystem(props, 'BorderBoxControlSplitControls');
  return {
    ...otherProps,
    centeredClassName: clsx(styles['centered-border-control'], className),
    className: clsx(styles['split-controls'], className),
    colors,
    enableAlpha,
    enableStyle,
    rightAlignedClassName: clsx(styles['right-border-control'], className),
    __experimentalIsRenderedInSidebar
  };
}